import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Card, CardContent, Button, Grid } from "@mui/material";

function Admin(props) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Administrador
      </Typography>
      <Typography sx={{ mb: 3 }}>
        Bienvenido Admin, ¿Que deseas hacer hoy?
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>Crear usuario</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Crear un nuevo usuario para el sistema.
              </Typography>
              <Button variant="contained" color="primary">Crear</Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>Editar usuario</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Editar la información de un usuario.
              </Typography>
              <Button variant="contained" color="primary">Editar</Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

Admin.propTypes = {};

export default Admin;
